export default __webpack_public_path__ + "static/media/rental.c3bda232.png";